<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("會員資料") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("會員資料") }}</div>
            </div>

            <md-card-content>
              <form novalidate class="md-layout" @submit.prevent="validateUser">
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.name">
                        <label for="name">{{ $t("姓名") }}</label>
                        <md-input
                          disabled
                          name="name"
                          id="name"
                          v-model="member.name"
                          @focus="clearError('name')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.email">
                        <label for="email">{{ $t("电邮") }}</label>
                        <md-input
                        disabled
                          name="email"
                          id="email"
                          v-model="member.email"
                          @focus="clearError('email')"
                        />
                      </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.phone">
                        <label for="phone">{{ $t("电话") }}</label>
                        <md-input
                        disabled
                          name="phone"
                          id="phone"
                          v-model="member.phone"
                          @focus="clearError('phone')"
                        />
                      </md-field>
                    </div>
                  </div>
                </div>
              </form>

              <div class="md-layout-item" style="text-align: right;">
                <router-link :to="{ name: 'member_password', params: {}}">
                  <md-button class="md-primary">{{ $t("更改密碼") }}</md-button>
                </router-link>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <md-dialog-alert
      :md-active.sync="show_payment_qr"
      md-title="微信支付"
      :md-content="payment_qr_message"
      md-confirm-text="確定"
    />
  </div>
</template>

<script>
export default {
  components: {},
  name: "checkout",
  bodyClass: "checkout-page",
  props: {},
  data() {
    return {

      show_payment_qr: false,
      payment_qr_message: "",
      member: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      order_error: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      products: [{}, {}, {}, {}],
      braintree_instance: false,
      txt_discount_code : '',
      discount_rate : false
    };
  },
  methods: {
    async getMember() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "member_detail_get.php",
        data: {
          member_id: this.$store.state.member_id,
        }
      });

      this.member = response.data.member;

      this.loader.hide();
    },
  },
  computed: {
    total_amount() {
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = 0;
      if(this.discount_rate){
        discount_amount = total_amount * this.discount_rate
      }
      total_amount = total_amount - discount_amount;
      total_amount = this.$numeral(total_amount).format("0,0.0");

      return total_amount;
    },

    discount_amount() {
      if(!this.discount_rate){
        return 0;
      }
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = total_amount * this.discount_rate;
      discount_amount = this.$numeral(discount_amount).format("0,0.0");

      return discount_amount;
    },
    display_products() {
      return this.products.map(p => {
        p.sub_total = parseFloat(p.price) * parseFloat(p.quantity);
        p.price = this.$numeral(p.price).format("0,0.0");
        p.sub_total = this.$numeral(p.sub_total).format("0,0.0");
        return p;
      });
    },
  },
  async created() {
    await this.getMember();
  },
  async mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.img-product {
  height: 150px;
}

.container-checkout_btn {
  display: flex;
  justify-content: flex-end;
}
</style>